import React, { useState } from 'react';
import { PUBS } from '../../data/portfolio';

const chartSVG = (
  <svg viewBox="0 0 600 240" width="100%" role="img" aria-label="BiLSTM cross-domain accuracy across three datasets">
    <g stroke="#1E271E" strokeWidth="1">
      <line x1="52" y1="200" x2="576" y2="200" />
      <line x1="52" y1="20" x2="52" y2="200" />
    </g>
    <g fill="#5A6B54" fontFamily="JetBrains Mono,monospace" fontSize="10">
      <text x="44" y="204" textAnchor="end">
        70%
      </text>
      <text x="44" y="140" textAnchor="end">
        78%
      </text>
      <text x="44" y="76" textAnchor="end">
        86%
      </text>
      <text x="140" y="222" textAnchor="middle">
        twitter
      </text>
      <text x="300" y="222" textAnchor="middle">
        amazon
      </text>
      <text x="460" y="222" textAnchor="middle">
        imdb
      </text>
    </g>
    {/* scale: 70% → y=200, 86% → y=76; y = 200 - (pct-70)*(124/16) */}
    <rect x="110" y="102" width="60" height="98" fill="#A8E831" opacity="0.85" />
    <rect x="270" y="119" width="60" height="81" fill="#A8E831" opacity="0.7" />
    <rect x="430" y="126" width="60" height="74" fill="#A8E831" opacity="0.55" />
    <g fill="#E6EDE2" fontFamily="JetBrains Mono,monospace" fontSize="11">
      <text x="140" y="94" textAnchor="middle">
        82.56%
      </text>
      <text x="300" y="111" textAnchor="middle">
        80.43%
      </text>
      <text x="460" y="118" textAnchor="middle">
        79.48%
      </text>
    </g>
    <text x="492" y="36" fill="#A8E831" fontFamily="JetBrains Mono,monospace" fontSize="10">
      BiLSTM
    </text>
  </svg>
);

const Research: React.FC = () => {
  const [open, setOpen] = useState<Record<number, boolean>>({ 0: true });

  return (
    <div className="page">
      <header>
        <h2>research</h2>
        <p>Peer-reviewed work and ongoing experiments.</p>
      </header>
      <div>
        {PUBS.map((p, i) => (
          <article key={p.title} className="pub">
            <div className="n">{String(i + 1).padStart(2, '0')}</div>
            <h3>{p.title}</h3>
            <p className="authors">
              {p.authors.map((a, idx) => (
                <React.Fragment key={a}>
                  {idx > 0 && ', '}
                  {a === 'Sahil Chordia' ? <b>{a}</b> : a}
                </React.Fragment>
              ))}
            </p>
            <p className="venue">{p.venue}</p>
            <div className="publinks">
              <button
                type="button"
                onClick={() => setOpen((prev) => ({ ...prev, [i]: !prev[i] }))}
              >
                abstract
              </button>
              {p.pdf && (
                <a href={p.pdf} target="_blank" rel="noopener noreferrer">
                  {p.linkLabel ?? 'source'} ↗
                </a>
              )}
            </div>
            <div className={`abstract${open[i] ? ' on' : ''}`}>
              <p>{p.abstract}</p>
              {p.chart && (
                <figure className="figure">
                  {chartSVG}
                  <figcaption>
                    Fig. 1: BiLSTM cross-domain accuracy (Twitter → Amazon / IMDb)
                  </figcaption>
                </figure>
              )}
            </div>
          </article>
        ))}
      </div>
    </div>
  );
};

export default Research;
